import {AxiosInstance} from "axios";
import API from "../../utils/api";
import {PaginatedRequest} from "../../models/core/paginated.request";
import {PaginatedResult} from "../../models/core/paginated.result";
import {Statement, StatementSummary} from "../../models/accounting/client-statements";

export class ClientStatementsService {
    api: AxiosInstance = API;

    public async getList(accountId: number, request: PaginatedRequest): Promise<PaginatedResult<Statement>> {
        return (await this.api.get<PaginatedResult<Statement>>(
            "accounts/" + accountId + "/statements",
            {
                params: request.toParams()
            }
        )).data;
    }

    public async getSummary(accountId: number): Promise<StatementSummary> {
        return (await this.api.get<StatementSummary>("accounts/" + accountId + "/statements/summary")).data;
    }
}

export const statementsService = new ClientStatementsService();

